<template>
  <div class="our detail">
     <p class="our_common_title">{{data.title}}</p>
     <p class="detail_time">{{data.updatetime | time}}</p>
     <div class="detail_content" >
      <img :src="domain+item.url" alt="" v-for='item in data.pictureurls'>
     </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      data:''
    }
  },
  watch:{
    '$route':function(to,from){
      this.getdetail()
    }
  },
  mounted:function(){
    this.domain=this._routerRoot.domain
    this.getdetail()
  },
  methods:{
    getdetail:function(){
      this.$axios.post(this.host+'/index.php?g=Index&m=Index&a=picture', this.$qs.stringify({
        id:this.$route.params.id
      }))
      .then(response => {
        console.log(response);
        this.data=response.data.data
        //console.log(this.dataList)
        /*this.data=response.data.cate;*/
      })
      .catch(error => {
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
.detail .our_common_title{
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  padding:0.3rem 0.2rem 0.2rem;
}
.detail_time{
  font-size: 0.24rem;
  color: #555555;
  padding-left: 0.2rem;
  margin-bottom: 0.5rem;
}
.detail_content{
  padding: 0.2rem;
}
.detail_content img{
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/cases_detail.vue